var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { DailyUsage } from './daily-usage';
export class ProductUsageModel {
    product;
    usages;
    productType;
    status;
    getUsageSumForMonth(date) {
        return this.usages
            .filter(({ date: usageDate }) => usageDate.getMonth() === date.getMonth())
            .reduce((total, { value }) => total + value, 0);
    }
    getUsagePercentForMonth(date, threshold) {
        return (this.getUsageSumForMonth(date) / threshold) * 100;
    }
    getDailyUsageValues() {
        return this.usages.map(({ value }) => value) || [];
    }
}
__decorate([
    Type(() => DailyUsage),
    __metadata("design:type", Array)
], ProductUsageModel.prototype, "usages", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Date]),
    __metadata("design:returntype", void 0)
], ProductUsageModel.prototype, "getUsageSumForMonth", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Date, Number]),
    __metadata("design:returntype", void 0)
], ProductUsageModel.prototype, "getUsagePercentForMonth", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProductUsageModel.prototype, "getDailyUsageValues", null);
//# sourceMappingURL=product-usage.js.map